import React from "react";
import Container from "react-bootstrap/Container";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import logo from "../../images/Acube-logo-blue.svg";
import "./header.css";

function ErrorHeader() {
    const location = useLocation();
    const navigate = useNavigate();

    const handleHomePageNavigation = (path) => {
        if (location.pathname === path) {
            // Smooth scroll to top if already on the same page
            window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
            navigate(path);
        }
    };

    return (
        <Navbar
            collapseOnSelect
            expand="xl"
            className="bg-body-tertiary page-header fixed-top"
            role="banner"
        >
            <Container fluid>
                <Navbar.Brand
                    as="a"
                    onClick={(e) => {
                        e.preventDefault();
                        handleHomePageNavigation("/");
                    }}
                    href="/"
                    aria-label="Go to Acube homepage"
                >
                    {/* Mobile logo */}
                    <img
                        src={logo}
                        alt="Acube Technologies logo"
                        width="130"
                        height="45"
                        className="img-fluid d-block d-lg-none"
                        decoding="async"
                        loading="eager"
                    />
                    {/* Desktop logo */}
                    <img
                        src={logo}
                        alt="Acube Technologies logo"
                        width="192"
                        height="45"
                        className="img-fluid d-none d-lg-block"
                        decoding="async"
                        loading="eager"
                    />
                </Navbar.Brand>
            </Container>
        </Navbar>
    );
}

export default ErrorHeader;
